import React from 'react';
import { useAppDispatch } from '../../store/hook';
import { closeModal } from '../../store/features/modalSlice';
import TextWinds from '../common/TextWinds';
import { IconButton } from '@material-tailwind/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export interface ModalExtendLinkProps {
  checkType: string;
  type?: string;
  message: string;
  purchaseLInk: Record<string, any>;
}
const ModalExtendLink = ({
  checkType,
  type,
  message,
  purchaseLInk,
}: ModalExtendLinkProps) => {
  const dispatch = useAppDispatch();
  const closeBtnhandler = () => {
    dispatch(closeModal());
  };
  const navigateBtnHandler = (loc: string, targetUrl: string) => {
    window.open(targetUrl, '_blank');
    dispatch(closeModal());
  };
  return (
    <div className="mountAnimation mb-40 flex w-[335px] flex-col gap-4 rounded-md bg-white p-4 shadow-card">
      <div className="flex w-full flex-row items-center">
        <div>{message}</div>
        <div className="ml-auto flex items-center">
          <IconButton
            variant="text"
            color="blue-gray"
            onClick={closeBtnhandler}
          >
            <XMarkIcon className="!h-[30px] !w-[30px]" />
          </IconButton>
        </div>
      </div>
      <div className="grid grid-flow-col-dense gap-2">
        <TextWinds
          type="button2"
          color="purple5"
          className="cursor-pointer rounded-md border p-2 text-center hover:bg-gray2"
          onClick={() =>
            navigateBtnHandler(
              'online',
              // option : 구매시 플랜 선택 후 옵션 선택을 띄울지 조건. 옵션은 교재를 추가하는 것.
              // option = false 일 경우 플랜 선택 후 옵션 선택을 띄우지 않음
              purchaseLInk.onlineLink + '?option=false',
            )
          }
        >
          온라인 연장
        </TextWinds>
        {'double' === checkType && (
          <TextWinds
            type="button2"
            color="purple5"
            className="cursor-pointer rounded-md border p-2 text-center hover:bg-gray2"
            onClick={() =>
              // option : 구매시 플랜 선택 후 옵션 선택을 띄울지 조건. 옵션은 교재를 추가하는 것.
              // option = true 일 경우 플랜 선택 후 옵션 선택을 띄움
              navigateBtnHandler('pack', purchaseLInk.packLink + '?option=true')
            }
          >
            교재팩 연장
          </TextWinds>
        )}
      </div>
    </div>
  );
};

export default ModalExtendLink;
